import React from "react"
import TableRow from "material-ui/Table/TableRow"
import EquipmentTimecardTableHeaderItem from "./EquipmentTimecardTableHeaderItem"
import { ITimecardDay } from "../../models"
interface IProps {
    timecardDays: ITimecardDay[]
    openDailyHistoryDrawer(date: number): void
}

const EquipmentTimecardTableHeader: React.SFC<IProps> = (props: IProps) => {
    return (
        <TableRow className="EquipmentTimecardTableHeader">
            {props.timecardDays.map((timecardDay, i) => {
                return <EquipmentTimecardTableHeaderItem timecardDay={timecardDay} openDailyHistoryDrawer={props.openDailyHistoryDrawer} date={i} key={i} />
            })}
        </TableRow>
    )
}

export default EquipmentTimecardTableHeader
